import React, { useState, useEffect } from "react";
import axios from "../common/axios";
import DashboardShell from "../layout/dashboard/DashboardShell";
import { Card, CardContent } from "../components/ui/card";

const Home = () => {
  const [userData, setUserData] = useState({});
  useEffect(() => {
    const fetchData = async () => {
      try {
        const userResponse = await axios.post(
          `/dpcurrent_user`,
          {},
          {
            withCredentials: true,
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
        setUserData(userResponse.data); // Set user data using Recoil
      } catch (userError) {
        console.error("Error fetching user data:", userError);
        // Handle error in fetching user data
      }
    };
    fetchData();
  }, []);

  return (
    <DashboardShell pageTitle="홈">
      <div className="flex-1 p-4">
        <h1 className="text-xl font-bold text-foreground mb-4">DP 시스템</h1>
        <Card>
          <CardContent className="p-6 text-sm leading-relaxed text-foreground">
            환영합니다. {userData.companyName}의 {userData.username}님.
            <br />이 웹시스템은 삼성중공업에서 사용되는 Unifier와 연동되는
            시스템입니다. 사용 중 문의가 있으시면 담당자에게 연락주시기
            바랍니다.
          </CardContent>
        </Card>
      </div>
    </DashboardShell>
  );
};
export default Home;
